import FuelDynamic from "./FuelDynamic";

export default FuelDynamic;
